import React from "react";
import { View } from "react-native";
import { Masks } from "react-native-mask-input";
import CaixaTextoInputIcone from "./TextBoxIcon";

const expirationMask = [/\d/, /\d/, "/", /\d/, /\d/];

export default function CardForm({
  cardNumber,
  setCardNumber,
  validCardNumber,
  cardExpiration,
  setCardExpiration,
  validCardExpiration,
  cardName,
  setCardName,
  validCardName,
  cardDocument,
  setCardDocument,
  validCardDocument,
}) {
  return (
    <View>
      <CaixaTextoInputIcone
        iconName={"credit-card-outline"}
        placeholderInput={"0000 0000 0000 0000"}
        onChangeTextInput={(cardNumber) => setCardNumber(cardNumber)}
        value={cardNumber}
        keyboardType={"numeric"}
        textContentType={"creditCardNumber"}
        maskInput={Masks.CREDIT_CARD}
        styleBox={{ width: "100%", marginTop: 20 }}
        {...validCardNumber}
      />
      {/* <View style={styles.viewExpirationCvv}> */}
      {/* <View style={styles.expiration}> */}
      <CaixaTextoInputIcone
        iconName={"calendar-range"}
        placeholderInput={"00/00"}
        onChangeTextInput={(cardExpiration) =>
          setCardExpiration(cardExpiration)
        }
        maxLength={5}
        value={cardExpiration}
        keyboardType={"numeric"}
        maskInput={expirationMask}
        autoComplete={"cc-exp"}
        styleBox={{ width: "100%" }}
        {...validCardExpiration}
      />
      <CaixaTextoInputIcone
        iconName={"text-account"}
        placeholderInput={"Nome"}
        onChangeTextInput={(cardName) => setCardName(cardName)}
        maxLength={20}
        value={cardName}
        textContentType={"name"}
        styleBox={{ width: "100%" }}
        autoCapitalize={"characters"}
        {...validCardName}
      />
      <CaixaTextoInputIcone
        iconName={"file-document-outline"}
        placeholderInput={"CPF ou CNPJ"}
        onChangeTextInput={(mask, cpfCnpj) => setCardDocument(cpfCnpj)}
        maxLength={20}
        value={cardDocument}
        textContentType={"name"}
        styleBox={{ width: "100%", marginBottom: 0 }}
        maskInput={Masks.BRL_CPF}
        keyboardType={"numeric"}
        autoCapitalize={"characters"}
        {...validCardDocument}
      />
    </View>
  );
}
